import { initInfo } from './info'

export const init = async () => {
  initInfo()

}

init()
